import { EcommerceCategories, EcommerceCategory } from '../models';

export function getActiveEcommerceCategories(ecommerceCategories: EcommerceCategories | null): EcommerceCategory[] {
  if (!ecommerceCategories?.items?.length) {
    return [];
  }
  return ecommerceCategories.items
    .filter((category) => category.status === 'active')
    .map((category) => ({
      ...category,
      subcategories: category.subcategories.filter((subcategory) => subcategory.status === 'active'),
    }));
}

export function getEcommerceCategoryLabelById(ecommerceCategories: EcommerceCategory[]): Record<string, string> {
  const map: Record<string, string> = {};
  for (const category of ecommerceCategories) {
    map[category.id] = category.label;
  }
  return map;
}

export function getEcommerceSubcategoryLabelById(ecommerceCategories: EcommerceCategory[]): Record<string, string> {
  const map: Record<string, string> = {};
  for (const category of ecommerceCategories) {
    for (const subcategory of category.subcategories) {
      map[subcategory.id] = subcategory.label;
    }
  }
  return map;
}